// Stored identifiers remain compatible with existing web and mobile habits.
export const ICONS: Array<{ emoji: string; label: string }> = [
  { emoji: "\u2764\uFE0F", label: "Heart" },
  { emoji: "\uD83D\uDCAA", label: "Flexed biceps" },
  { emoji: "\uD83C\uDFC3", label: "Runner" },
  { emoji: "\uD83E\uDDD8", label: "Meditation" },
  { emoji: "\uD83D\uDCA7", label: "Water drop" },
  { emoji: "\uD83C\uDFCB\uFE0F", label: "Weight lifting" },
  { emoji: "\uD83D\uDE34", label: "Sleeping" },
  { emoji: "\uD83C\uDF19", label: "Moon" },
  { emoji: "\u2615", label: "Coffee" },
  { emoji: "\uD83C\uDF73", label: "Cooking" },
  { emoji: "\uD83D\uDC8A", label: "Pill" },
  { emoji: "\uD83E\uDDB7", label: "Tooth" },
  { emoji: "\u2600\uFE0F", label: "Sun" },
  { emoji: "\uD83E\uDDA0", label: "Microbe" },
  { emoji: "\uD83D\uDC63", label: "Footprints" },
  { emoji: "\uD83D\uDCDA", label: "Books" },
  { emoji: "\uD83C\uDCCF", label: "Playing card" },
  { emoji: "\uD83C\uDF0D", label: "Globe" },
  { emoji: "\uD83C\uDFA7", label: "Headphones" },
  { emoji: "\uD83C\uDF93", label: "Graduation cap" },
  { emoji: "\u270D\uFE0F", label: "Writing hand" },
  { emoji: "\uD83D\uDCD6", label: "Open book" },
  { emoji: "\u265F\uFE0F", label: "Chess pawn" },
  { emoji: "\uD83C\uDFB5", label: "Music note" },
  { emoji: "\uD83D\uDCF0", label: "Newspaper" },
  { emoji: "\uD83D\uDCCB", label: "Clipboard" },
  { emoji: "\uD83E\uDDE0", label: "Brain" },
  { emoji: "\uD83D\uDCE7", label: "Email" },
  { emoji: "\uD83C\uDF45", label: "Tomato" },
  { emoji: "\uD83D\uDCF1", label: "Phone" },
  { emoji: "\uD83E\uDDF9", label: "Broom" },
  { emoji: "\uD83D\uDDD3\uFE0F", label: "Calendar" },
  { emoji: "\uD83C\uDFAF", label: "Bullseye" },
  { emoji: "\u2728", label: "Sparkles" },
  { emoji: "\uD83C\uDFA8", label: "Art palette" },
  { emoji: "\uD83D\uDE04", label: "Smiling face" },
  { emoji: "\uD83C\uDF1F", label: "Glowing star" },
  { emoji: "\uD83D\uDC86", label: "Face massage" },
  { emoji: "\uD83E\uDEE7", label: "Bubbles" },
  { emoji: "\uD83D\uDCDE", label: "Telephone" },
  { emoji: "\uD83D\uDCAC", label: "Speech bubble" },
  { emoji: "\uD83D\uDC9A", label: "Green heart" },
  { emoji: "\uD83C\uDF89", label: "Party popper" },
  { emoji: "\uD83D\uDC42", label: "Ear" },
  { emoji: "\uD83D\uDE4F", label: "Folded hands" },
  { emoji: "\uD83D\uDC4B", label: "Waving hand" },
  { emoji: "\u270F\uFE0F", label: "Pencil" },
  { emoji: "\uD83D\uDCF7", label: "Camera" },
  { emoji: "\uD83D\uDD8A\uFE0F", label: "Pen" },
  { emoji: "\uD83D\uDCA1", label: "Light bulb" },
  { emoji: "\uD83C\uDFB6", label: "Music notes" },
  { emoji: "\uD83E\uDDF6", label: "Yarn" },
  { emoji: "\uD83D\uDD8C\uFE0F", label: "Paintbrush" },
  { emoji: "\uD83D\uDCB3", label: "Credit card" },
  { emoji: "\uD83D\uDCB0", label: "Money bag" },
  { emoji: "\uD83D\uDED2", label: "Shopping cart" },
  { emoji: "\uD83D\uDCC8", label: "Chart up" },
  { emoji: "\uD83D\uDCCA", label: "Bar chart" },
  { emoji: "\uD83D\uDE80", label: "Rocket" },
  { emoji: "\uD83D\uDCDD", label: "Memo" },
  { emoji: "\uD83D\uDD25", label: "Fire" },
  { emoji: "\uD83C\uDF3F", label: "Herb" },
  { emoji: "\uD83C\uDF33", label: "Tree" },
  { emoji: "\uD83C\uDF05", label: "Sunrise" },
  { emoji: "\uD83D\uDCF5", label: "No phone" },
  { emoji: "\uD83D\uDEAB", label: "Prohibited" },
  { emoji: "\uD83E\uDDBF", label: "Mechanical leg" },
  { emoji: "\uD83D\uDCD3", label: "Notebook" },
  { emoji: "\uD83C\uDF2C\uFE0F", label: "Wind" },
  { emoji: "\uD83D\uDD0D", label: "Magnifying glass" },
  { emoji: "\uD83D\uDCE6", label: "Package" },
  { emoji: "\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC66", label: "Family" },
  { emoji: "\uD83E\uDDD1\u200D\uD83C\uDFEB", label: "Teacher" },
  { emoji: "\uD83E\uDD1D", label: "Handshake" },
  { emoji: "\uD83D\uDC68\u200D\uD83C\uDF73", label: "Cook" },
  { emoji: "\uD83C\uDFAD", label: "Performing arts" },
  { emoji: "\uD83C\uDF7D\uFE0F", label: "Fork and knife" },
  { emoji: "\uD83D\uDCB8", label: "Money with wings" },
];
